import { h } from 'preact'
import { keygen } from '@utils/misc'

export default function VatPicker({ vats, className }) {
	const setVat = url => {
		setTimeout(() => {
			document.documentElement.classList.add('--will-reload')
		}, 100)

		fetch(url)
			.then(res => {
				if (res.status === 200) window.location.reload()
			})
			.catch(err => {
				console.warn('Error while setting vat', err)
			})
	}

	return (
		<div className={className ?? 'vat-types'}>
			{!!vats?.length &&
				vats.map(vat => (
					<span
						key={keygen('vat')}
						role="button"
						onClick={() => setVat(vat.fetchUrl)}
						style={{ cursor: 'pointer' }}
						tabIndex={0}
					>
						{vat.isSelected ? <strong>{vat.text}</strong> : vat.text}
					</span>
				))}
		</div>
	)
}
